import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import {Provider} from 'react-redux';
import allReducers from './reducers';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import casesMiddleware from './store/CasesMiddleware';

const middleware = applyMiddleware(casesMiddleware);

const store = createStore(allReducers, middleware);
ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
